import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  createContext,
  useContext,
} from "react"

export interface EditInsightModalContextValue {
  openEditInsightModal: (insight: Insight) => void;
}

type ContextType = EditInsightModalContextValue | null
export const EditInsightModalContext = createContext<ContextType>(null)

export function useEditInsightModalContext() {
  const context = useContext(EditInsightModalContext)

  if (context === null) {
    throw new Error("EditInsightModal components must be wrapped in <EditInsightModalContext />")
  }

  return context
}
